









export default
  props:
    label:
      type: String
      default: ''
    small_label:
      type: Boolean
      default: false
    fifty:
      type: Boolean
      default: false
    large_label:
      type: Boolean
      default: false
    large_space:
      type: Boolean
      default: false
    middle_label:
      type: Boolean
      default: false
    no_left:
      type: Boolean
      default: false
    flex_end:
      type: Boolean
      default: false
    reverse:
      type: Boolean
      default: false
    draw_background:
      type: Boolean
      default: false
